import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {LEGACY_FONT_PROXIMA_13} from 'styles/FontConstants';
import {RED} from 'ui-library/Colors';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';

import {
  BulkUnlinkSpec,
  CATEGORICAL_UNLINK_SPEC_NAME,
  CategoricalUnlinkSpec,
  isCategoricalUnlinkSpec,
  SchemaFieldInfoById,
} from './BulkUnlinkPartsConstants';

interface BulkUnlinkPartsDropdownProps {
  selectedField: BulkUnlinkSpec;
  setSelectedField: (selectedField: string) => void;
  schemaFieldInfoById: SchemaFieldInfoById;
}

export default function BulkUnlinkPartsDropdown({
  selectedField,
  setSelectedField,
  schemaFieldInfoById,
}: BulkUnlinkPartsDropdownProps): JSX.Element {
  return (
    <SelectDropdown
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} value={selectedField}>
          <Section key="categorical">
            {Object.values(CategoricalUnlinkSpec).map((spec) => (
              <Option
                key={spec}
                value={spec}
                onSelect={(schemaField: CategoricalUnlinkSpec) => {
                  setSelectedField(schemaField);
                }}
              >
                {CATEGORICAL_UNLINK_SPEC_NAME[spec]}
              </Option>
            ))}
          </Section>
          <Section key="schemaField">
            {Object.keys(schemaFieldInfoById).map((schemaFieldId) => {
              const numInvalidParts = schemaFieldInfoById[schemaFieldId].tagSpecs.filter(
                (tagSpec) => tagSpec.partSequenceIds.length > 0 && tagSpec.validationError
              ).length;
              return (
                <Option
                  key={schemaFieldId}
                  value={schemaFieldId}
                  onSelect={(schemaFieldId: string) => {
                    setSelectedField(schemaFieldId);
                  }}
                >
                  <span>{schemaFieldInfoById[schemaFieldId].schemaFieldName}</span>
                  {numInvalidParts > 0 && (
                    <span
                      className={css(styles.numInvalidParts)}
                    >{`${numInvalidParts} invalid part link ${pluralize(numInvalidParts, 'field')}`}</span>
                  )}
                </Option>
              );
            })}
          </Section>
        </Menu>
      }
      displayName={
        isCategoricalUnlinkSpec(selectedField)
          ? CATEGORICAL_UNLINK_SPEC_NAME[selectedField]
          : schemaFieldInfoById[selectedField].schemaFieldName
      }
    />
  );
}

const styles = StyleSheet.create({
  numInvalidParts: {
    ...LEGACY_FONT_PROXIMA_13,
    color: RED,
    float: 'right',
  },
});
